import React, { useEffect, useState } from "react";
import { Button, TextField } from "../../primary";
import styles from "./assign.module.scss";
import { Toggle } from "./toggle";
import PlusIcon from "../../../static/images/plus-icon_white.svg";

const SectionBlock = ({
  section,
  sectionIndex,
  renderQuestion,
  handleSectionTitle,
  handleSectionToggle,
  sectionError,
  sectionRefs,
  errors,
  onDragOver,
  onDrop,
  onDragStart,
  dragOverTarget,
  onAddQuestion,
}) => {
  const [sectionTitle, setSectionTitle] = useState(section?.name || "");

  useEffect(() => {
    setSectionTitle(section?.name || "");
  }, [section?.name]);

  return (
    <div
      key={sectionIndex}
      onDragOver={(e) => onDragOver(e, sectionIndex, section.questions.length)}
      onDrop={() => onDrop(sectionIndex, section.questions.length)}
      className={styles.section_block}
      ref={(el) => (sectionRefs.current[sectionIndex] = el)}
    >
      <div className={styles.section_header}>
        <div className="">
          <TextField
            id={`section${sectionIndex}`}
            name={`section${sectionIndex}`}
            classes={{
              column: `${styles.section_heading} pb-2`,
              inputColumn: `p-0 outline`,
              inputClassName: `${styles.section_title} ${section.name ? styles.section_title_foc : ""} ${styles.fontBold}`,
            }}
            type="text"
            errors={errors}
            placeholder={`Enter section title`}
            value={sectionTitle}
            onChange={(e) => setSectionTitle(e.target.value)}
            onBlur={() => handleSectionTitle(sectionTitle, sectionIndex)}
          />
          {sectionError?.[sectionIndex] && (
            <div className="pl-1">
              <span className={`${styles.error_message}`}>{sectionError?.[sectionIndex]}</span>
            </div>
          )}
        </div>
        <Toggle checked={section?.isMandatory === 1} type="section" index={sectionIndex} onChange={handleSectionToggle} />
      </div>

      {section.questions.map((value, i) => (
        <div
          key={value.tempId}
          draggable
          onDragStart={() => onDragStart(sectionIndex, i, value.tempId)}
          onDragOver={(e) => onDragOver(e, sectionIndex, i)}
          onDrop={() => onDrop(sectionIndex, i)}
        >
          {/* Render “Drop Here” if dragging over this position */}
          {dragOverTarget.sectionIndex === sectionIndex && dragOverTarget.questionIndex === i && (
            <div className={styles.drop_placeholder}>Drop here...</div>
          )}

          {renderQuestion(value, i === section.questions.length - 1, i, sectionIndex, section?.isMandatory === 1)}
        </div>
      ))}

      {section?.questions?.length === 0 && (
        <div className={`col-12 ${styles.noSelection}`}>
          <Button classes={{ className: `btn ${styles.btn_customs} ${styles.btn_smalls}` }} type="button" onClick={() => onAddQuestion(sectionIndex)}>
          <img src={PlusIcon} alt="addQuestion" />
          Add Question
        </Button>
        </div>
      )}

      {dragOverTarget.sectionIndex === sectionIndex && dragOverTarget.questionIndex === section.questions.length && (
        <div
          className={styles.drop_placeholder}
          onDragOver={(e) => onDragOver(e, sectionIndex, section.questions.length)}
          onDrop={() => onDrop(sectionIndex, section.questions.length)}
        >
          Drop here...
        </div>
      )}
    </div>
  );
};

export default SectionBlock;
